import { AlertTriangle } from 'lucide-react'
import { useTranslation } from 'react-i18next'

export default function ConfirmDialog({ open, title, message, onConfirm, onCancel, variant = 'danger', loading = false }) {
  const { t } = useTranslation()
  if (!open) return null

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4"
      style={{ background: 'rgba(0,0,0,0.5)', backdropFilter: 'blur(4px)' }}
      onClick={onCancel}
    >
      <div
        className="hg-card p-6 w-full max-w-sm animate-in"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-start gap-4 mb-5">
          <div
            className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0"
            style={{
              background: variant === 'danger' ? 'rgba(186,26,26,0.1)' : 'rgba(255,109,0,0.1)',
              color: variant === 'danger' ? '#BA1A1A' : '#FF6D00',
            }}
          >
            <AlertTriangle size={20} />
          </div>
          <div>
            <h3
              className="font-black text-ink text-base mb-1"
              style={{ fontFamily: 'Cairo, sans-serif' }}
            >
              {title}
            </h3>
            <p className="text-sm text-dim" style={{ fontFamily: 'Tajawal, sans-serif' }}>
              {message}
            </p>
          </div>
        </div>
        <div className="flex gap-3">
          <button
            onClick={onConfirm}
            disabled={loading}
            className="flex-1 py-2.5 rounded-xl font-bold text-sm text-white transition-all"
            style={{
              background: variant === 'danger' ? '#BA1A1A' : '#FF6D00',
              fontFamily: 'Cairo, sans-serif',
              opacity: loading ? 0.6 : 1,
            }}
          >
            {loading ? '...' : t('common.confirm')}
          </button>
          <button
            onClick={onCancel}
            disabled={loading}
            className="flex-1 py-2.5 rounded-xl font-bold text-sm transition-all"
            style={{
              background: '#F3F3F3',
              color: '#454652',
              fontFamily: 'Cairo, sans-serif',
            }}
          >
            {t('common.cancel')}
          </button>
        </div>
      </div>
    </div>
  )
}
